import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export default function AlertAcknowledged() {
  const [searchParams] = useSearchParams();
  const alertId = searchParams.get('id');

  return (
    <div className="min-h-screen bg-[hsl(222,47%,11%)] flex items-center justify-center p-4">
      <div className="bg-[hsl(217,33%,17%)] rounded-xl border border-[hsl(217,19%,27%)] p-8 max-w-md w-full text-center" data-testid="alert-ack-page">
        <CheckCircle2 className="w-16 h-16 text-green-400 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-white mb-2">Alert Acknowledged</h1>
        <p className="text-[hsl(215,20%,65%)] mb-6">
          This alert has been marked as acknowledged. No further escalation will be sent.
        </p>
        {alertId && (
          <p className="text-xs text-[hsl(215,20%,45%)]">Alert ID: {alertId}</p>
        )}
      </div>
    </div>
  );
}
